import { Box, Paper, Typography, Container } from "@mui/material";
import moment from "moment-timezone";
import Page from "../../component/Page";
import NextBreadcrumbs from "../../component/NextBreadcrumbs";
import MoreResources from "../../component/MoreResources";
import DOMPurify from "isomorphic-dompurify";
import Head from "next/head";
import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { getContentFromHtml } from "../../component/Utils/utils";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
} from "react-share";
import getBioRoute from "../../utils/bioLookup";


const Article = () => {
  const router = useRouter();
  const articleId = router?.query?.id;
  const [post, setPost] = useState(null);
  const url = useRef();

  useEffect(() => {
    if (!articleId) {
      return;
    }
    fetch(`/api/post/${articleId}`).then(res => res.json()).then(json => {
      setPost(json);
    });
    url.current = window.location.href;
  }, [router]);

  if (post?.error) {
    router.push("/404");
  }
  if (post == null || !post?.author?.displayName) {
    return;
  }
  // this santize html and restyle images
  const cleanedHTML = (() => {
    if (!post?.content) {
      return null;
    }
    const tempElement = document.createElement('div');
    tempElement.innerHTML = DOMPurify.sanitize(post?.content);
    const images = tempElement.getElementsByTagName('img');
    for (let i = 0; i < images.length; i++) {
      images[i].style.maxWidth = '100%';
      images[i].style.height = 'auto';
    }
    const hyperlinks = tempElement.getElementsByTagName('a');
    for (let i = 0; i < hyperlinks.length; i++) {
      hyperlinks[i].target = '_blank';
      hyperlinks[i].rel = "noopener";
    }
    const modifiedHtmlString = tempElement.innerHTML;
    return modifiedHtmlString;
  })();

  return (
    <Page>
      <Head>
        <title>{`${post?.title} | Kentucky Climate Center`}</title>
        <meta name="description" content={`An article about ${post?.title} by ${post?.author?.displayName}`}></meta>
        <meta name="author" content={post?.author?.displayName}></meta>
        <meta name="keywords" content={`Kentucky Climate Center, Kentucky Mesonet, weather, climate, ${post?.title}, ${post?.author?.displayName}`}></meta>
        <meta property="og:title" content={`${post?.title} | Kentucky Climate Center`}></meta>
        <meta property="og:url" content={`kyclimate.org/topic/${articleId}`}></meta>
        <meta property="og:type" content="article" />
        <meta property="og:description" content={getContentFromHtml(cleanedHTML)}></meta>
        {
          (post?.images && post?.images.length > 0) && <meta property="og:image" content={post.images[0]?.url}></meta>
        }
      </Head>
      <Container sx={{ pt: 10 }} elevation={3}>
        <NextBreadcrumbs title={post?.title}></NextBreadcrumbs>
        <Paper sx={{ p: 5, my: 3 }}>
          <Typography variant="h2">{post?.title}</Typography>
          <Box sx={{ cursor: "pointer" }} onClick={() => {
            const route = getBioRoute(post?.author?.id);
            if (route !== null) {
              router.push(route)
            }
          }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img src={post?.author?.image?.url.replace("//", "https://")}></img>
              <Box sx={{ pl: 1 }}>
                <Typography variant="subtitle1">
                  By {post?.author?.displayName}
                </Typography>
                <Typography variant="subtitle2">
                  Updated {moment(post?.updated).toLocaleString()}
                </Typography>
              </Box>
            </Box>

          </Box>
          <Box sx={{ py: 3 }}>
            {cleanedHTML && (
              <div dangerouslySetInnerHTML={{ __html: cleanedHTML }}></div>
            )}
          </Box>
          <Box>
            <Typography variant="h4">Share</Typography>
            <FacebookShareButton url={url.current}><FacebookIcon></FacebookIcon></FacebookShareButton>
            <TwitterShareButton url={url.current}><TwitterIcon></TwitterIcon></TwitterShareButton>
            <LinkedinShareButton url={url.current}><LinkedinIcon></LinkedinIcon></LinkedinShareButton>
            <EmailShareButton url={url.current}><EmailIcon></EmailIcon></EmailShareButton>
          </Box>
        </Paper>
      </Container>
      <MoreResources filterId={[post.id]}></MoreResources>
    </Page>
  );
};

export default Article;